/**
 * SHA-256 hex 해시. PII(이메일) → customerEmailHash 변환에 사용.
 *
 * `window.crypto.subtle.digest('SHA-256', ...)`만 지원한다.
 * - HTTPS 환경 + localhost(secure context로 간주) 모두 동작.
 * - file://이나 HTTP origin은 미지원 (안전한 SDK 사용 환경 아님).
 *
 * 순수 JS fallback은 본 PR 범위 밖. 필요 시 후속 PR에서 별도 도입.
 */
const subtleAvailable = (): boolean => {
  if (typeof crypto === 'undefined') return false
  if (typeof crypto.subtle === 'undefined') return false
  return typeof crypto.subtle.digest === 'function'
}

const bytesToHex = (bytes: Uint8Array): string => {
  const out: string[] = []
  for (const byte of bytes) out.push(byte.toString(16).padStart(2, '0'))
  return out.join('')
}

const sha256Hex = async (message: string): Promise<string> => {
  if (!subtleAvailable()) {
    throw new Error('SubtleCrypto unavailable. @edgelinkapp/sdk-web requires HTTPS or localhost (secure context).')
  }
  const bytes = new TextEncoder().encode(message)
  const hashBuffer = await crypto.subtle.digest('SHA-256', bytes)
  return bytesToHex(new Uint8Array(hashBuffer))
}

export { sha256Hex, subtleAvailable }
